<div class="mat-dialog-camera-view">
    <div mat-dialog-title class="dialog-title">
        <h2>Live Views {{data?.siteName && '-' + data?.siteName }}</h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="live-view-section">
            <div class="no_record_found_msg" *ngIf="cameraListData.length === 0 && !liveViewsLoading">
                No Records Found!
            </div>
            <div class="no_record_found_msg" *ngIf="liveViewsLoading">
                Fetching Live Views...
            </div>
            <div class="row gx-3 gy-3" *ngIf="cameraListData.length > 1">
                <div *ngFor="let camera of cameraListData ;let i=index;" class="col-4 live-view-card">
                    <mat-card class="liveview-card">
                        <div class="borderBox">
                            <mat-card-content>
                                <div class="live-image">
                                    <!-- <img src="{{liveView_ImageUrl}}?potentialId={{potentialId}}&camUniqueId={{camera.camUniqueId}}&timestamp={{getCurrentTime}}"
                                        class="camLiveView" href="#popup1" ngbTooltip="{{camera.cameraName}}"
                                        style="cursor:pointer;"> -->
                                    <img src="{{liveView_ImageUrl}}?potentialId={{potentialId}}&camUniqueId={{camera.camUniqueId}}&station=recordingStation{{counter}}"
                                        class="camLiveView" href="#popup1" ngbTooltip="{{camera.cameraName}}"
                                        style="cursor:pointer;">
                                </div>
                            </mat-card-content>
                            <mat-card-footer>
                                <div class="iconMain">
                                    <div class="info">
                                        <span *ngIf="camera.connected === true" matTooltip="Connected"
                                            class="up-status"></span>
                                        <span *ngIf="camera.connected === false" matTooltip="Not Connected"
                                            class="down-status"></span>
                                        <span class="cname"> {{camera.cameraName}}</span>
                                    </div>
                                </div>
                            </mat-card-footer>
                        </div>
                    </mat-card>
                </div>
            </div>
            <div class="row gx-3 gy-3" *ngIf="cameraListData.length === 1">
                <div *ngFor="let camera of cameraListData ;let i=index;" class="col-12 live-view-card">
                    <mat-card class="liveview-card">
                        <div class="borderBox">
                            <mat-card-content>
                                <div class="live-image">
                                    <!-- <img src="{{liveView_ImageUrl}}?potentialId={{potentialId}}&camUniqueId={{camera.camUniqueId}}&timestamp={{getCurrentTime}}"
                                        class="camLiveView" href="#popup1" ngbTooltip="{{camera.cameraName}}"
                                        style="cursor:pointer;"> -->
                                    <img src="{{liveView_ImageUrl}}?potentialId={{potentialId}}&camUniqueId={{camera.camUniqueId}}&station=recordingStation{{counter}}"
                                        class="camLiveView" href="#popup1" ngbTooltip="{{camera.cameraName}}"
                                        style="cursor:pointer;">
                                </div>
                            </mat-card-content>
                            <mat-card-footer>
                                <div class="iconMain">
                                    <div class="info">
                                        <span *ngIf="camera.connected === true" matTooltip="Connected"
                                            class="up-status"></span>
                                        <span *ngIf="camera.connected === false" matTooltip="Not Connected"
                                            class="down-status"></span>
                                        <span class="cname"> {{camera.cameraName}}</span>
                                    </div>
                                </div>
                            </mat-card-footer>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>